import { AbstractControl, FormControl, ValidationErrors, ValidatorFn } from '@angular/forms'

import { VALID_ODDS } from '../../../../../shared/constants/common.constant'

export function validOddValidator(): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		const formControl = control as FormControl
		const currentValue = Number(formControl.value)

		if (formControl?.value && !VALID_ODDS.includes(currentValue)) {
			return { validOdd: true }
		}

		return null
	}
}
